import { useState, useEffect } from "react";

// material
import { styled } from "@mui/material/styles";
import { Card, Stack, Container, Typography, Box } from "@mui/material";
// components
import Page from "../components/Page";
import { LoginForm } from "../components/authentication/login";
import Logo from "src/components/Logo";
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  flexGrow: 1,
  minHeight: 0,
  background:
    theme.isAmik && theme.palette.brand
      ? theme.palette.brand.gradient
      : `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 50%, ${theme.palette.secondary.main} 100%)`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
  },
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
    animation: 'float 20s ease-in-out infinite',
  },
  '@keyframes float': {
    '0%, 100%': { transform: 'translateY(0px)' },
    '50%': { transform: 'translateY(-20px)' },
  },
}));

//const SectionStyle = styled(Card)(({ theme }) => ({
//   width: "100%",
//   maxWidth: 464,
//   display: "flex",
//   flexDirection: "column",
//   justifyContent: "center",
//   margin: theme.spacing(2, 0, 2, 2),
// }));

// const ContentStyle = styled("div")(({ theme }) => ({
//   maxWidth: 480,
//   margin: "auto",
//   display: "flex",
//   minHeight: "100vh",
//   flexDirection: "column",
//   justifyContent: "center",
//   padding: theme.spacing(12, 0),
// }));

// ----------------------------------------------------------------------

export default function Login() {
  const [error, setError] = useState(null);
  useEffect(() => {
    const redirectedURL = new URLSearchParams(window.location.search);
    const loginStatus = redirectedURL.get("emailVerificationStatus");
    switch (loginStatus) {
      case "alreadyVerified":
        setError("Email is already verified, Please login.");
        break;
      case "false":
        setError("Email verification failed, Please try again or contact us.");
        break;
      default:
        //  Token.get() && (window.location.href = enums.path.DASHBOARD_APP);
        break;
    }
  }, []);

  return (
    <RootStyle>
      <Container maxWidth="sm">
        <Card
          sx={{
            p: { xs: 2.5, sm: 3.5, md: 4 },
            boxShadow: (theme) => theme.customShadows.z24,
            borderRadius: 3,
            background: '#ffffff',
            border: (theme) => `1px solid ${theme.palette.grey[200]}`,
            width: '100%',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Stack sx={{ mb: { xs: 3, sm: 4 }, textAlign: 'center' }}>
            <Box sx={{
              mb: { xs: 2, sm: 3 },
              '& img': { 
                maxWidth: '140px', 
                height: 'auto',
                filter: 'none',
                mixBlendMode: 'normal'
              } 
            }}>
              <Logo />
            </Box>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                color: "text.primary",
                fontWeight: 700,
                mb: 1,
                background: (theme) =>
                  theme.isAmik && theme.palette.brand
                    ? theme.palette.brand.gradient
                    : 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Charging Management System
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: "text.secondary",
                fontWeight: 400,
                opacity: 0.8
              }}
            >
              Sign in to your account to continue
            </Typography>
          </Stack>
          
          <LoginForm />
        </Card>
      </Container>
    </RootStyle>
  );
}
